<template>
  <section  class="consulting-hero rounded-lg p-4 py-10 lg:p-8 relative overflow-hidden" :class="{'rtl-hero': isRtl}">
    <div class="absolute left-0 bottom-0 w-full h-full transform translate-y-6 hidden lg:block">
        <img src="@/assets/images/consulting-hero-bg.svg" alt="" role="presentation">
    </div>           
    <div class="lg:flex lg:justify-evenly lg:items-center relative">
     <div>
         <img src="@/assets/images/doctor-consulting.svg" alt="" role="presentation" style="max-width: 360px">
     </div>
     <div class="mt-12 lg:mt-0">
         <head-line :level="2" :size="3" :bold="true">{{ $t('pages.home.heroConsult.title') }}</head-line>
         <ul class="mt-6 consulting-list text-gray-600 text-base">
             <li class="mb-2"><span class="circle-list" role="presentation" :class="[{'mr-3': !isRtl},{'ml-3': isRtl}]"></span>{{ $t('pages.home.heroConsult.list[0]') }}</li>
             <li class="mb-2"><span class="circle-list" role="presentation" :class="[{'mr-3': !isRtl},{'ml-3': isRtl}]"></span>{{ $t('pages.home.heroConsult.list[1]') }}</li>
             <li><span class="circle-list" role="presentation" :class="[{'mr-3': !isRtl},{'ml-3': isRtl}]"></span>{{ $t('pages.home.heroConsult.list[2]') }}.</li>
         </ul>
         <div class="mt-12">
             <a href="http://app.awronore.krd" class="btn btn-linear text-awro-100 font-semibold rounded">{{ $t('btn.download') }}</a>
         </div>
     </div>
    </div>
  </section>
</template>

<script>
import HeadLine from '@/components/theme/HeadLine'
import {mapGetters} from 'vuex'

export default {
    name: "ConsultingHero",
    components: {HeadLine},
    computed: {
        ...mapGetters({
            isRtl: ['locale/IS_RTL']
        })
    }
}
</script>

<style>
    .consulting-hero {
        background: #fafafa
    }

    .circle-list {
        position: relative;
        display: inline-block;
        width: 16px;
        height: 16px;
        background: #ddd;
        border-radius: 100%;
        vertical-align: middle;
    }
    .circle-list::after {
        content: ' ';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 8px;
        height: 8px;
        background: linear-gradient(90deg, #29335C 0%, #00BFBC 100%);
        transform: translate(-50%, -50%);
        border-radius: 100%;
    }
    .btn-linear {
        background: linear-gradient(270deg, #29335c, #00bfbc);
        background-size: 400% 400%;
        -webkit-animation: AnimationName 8s ease infinite alternate;
        -moz-animation: AnimationName 8s ease infinite alternate;
        -o-animation: AnimationName 8s ease infinite alternate;
        animation: AnimationName 8s ease infinite alternate;
    }
    @-webkit-keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 50%}
    100%{background-position:0% 50%}
    }
    @-moz-keyframes AnimationName {
        0%{background-position:0% 50%}
        50%{background-position:100% 50%}
        100%{background-position:0% 50%}
    }
    @-o-keyframes AnimationName {
        0%{background-position:0% 50%}
        50%{background-position:100% 50%}
        100%{background-position:0% 50%}
    }
    @keyframes AnimationName {
        0%{background-position:0% 50%}
        50%{background-position:100% 50%}
        100%{background-position:0% 50%}
    }

</style>